(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawquo-trust-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pawquo-trust-banner')) {
    customElements.define(
      'pawquo-trust-banner',
      class extends HTMLElement {
        connectedCallback() {
          this.messages = Array.from(this.querySelectorAll('[data-trust-message]'));
          this.toggle = this.querySelector('[data-trust-toggle]');
          this.index = 0;
          this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (this.messages.length < 2 || this.paused) return;

          this.start();
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => {
            if (this.toggle.getAttribute('aria-pressed') === 'false') this.start();
          });
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => {
            if (this.toggle.getAttribute('aria-pressed') === 'false') this.start();
          });
          this.toggle.addEventListener('click', () => this.toggleRotation());
        }

        disconnectedCallback() {
          this.stop();
        }

        showNext() {
          this.messages[this.index].hidden = true;
          this.index = (this.index + 1) % this.messages.length;
          this.messages[this.index].hidden = false;
        }

        start() {
          this.stop();
          this.timer = window.setInterval(() => this.showNext(), 5000);
        }

        stop() {
          window.clearInterval(this.timer);
        }

        toggleRotation() {
          const willPause = this.toggle.getAttribute('aria-pressed') === 'false';
          this.toggle.setAttribute('aria-pressed', String(willPause));
          this.toggle.setAttribute(
            'aria-label',
            willPause ? this.dataset.playLabel : this.dataset.pauseLabel
          );

          if (willPause) {
            this.stop();
          } else {
            this.start();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
